import React from "react";

const Maintenance = () => {
   
  
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#f5f5f5',
      padding: '10px'  
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        padding: '15px',  
        maxWidth: '600px',
        width: '100%',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '90vh'  
      }}>
        <img 
          src= '/assets/Modulo_mantimiento.png'
          alt="Maintenance" 
          style={{
            height: 'auto',
            maxHeight: '85vh',  
            width: 'auto',  
            maxWidth: '400px',  
            objectFit: 'contain',  
            display: 'block'
          }}
        />
      </div>
    </div>
  );
};

export default Maintenance;
